import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/app/airbnb-split-calculator/AirbnbSplitCalculatorContent.tsx");
